<template>
  <v-data-table
    :items="scores"
    :headers="computedHeaders"
    :hide-actions="true"
    class="elevation-1"
    disable-initial-sort
  >
    <template v-slot:items="props">
      <td class="text-xs-left">
        <router-link :to="{ name: 'game', params: { id: props.item.game_id } }">{{ props.item.title }}</router-link>
      </td>
      <td class="text-xs-right">{{ props.item.value | formatNumber }}</td>
      <td class="text-xs-right">{{ props.item.created_at | formatDate }}</td>
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: ['scores'],
  computed: {
    computedHeaders() {
      return this.headers.filter(h => !h.hide || !this.$vuetify.breakpoint[h.hide]);
    },
  },
  data() {
    return {
      headers: [
        { text: 'Jeux', value: 'title' },
        { text: 'Score', value: 'value', align: 'right' },
        { text: 'Date', value: 'created_at', align: 'right' },
      ],
    };
  },
};
</script>
